import HotelEntity from '../Entity/Hotel';
import buildHotelData from './service/buildHotelData';


/**
 * HotelFactory
 *
 * @param {Object} data - hotel data
 * @param {CountriesRepository | undefined} countriesRepository - CountriesRepository instance.
 * Необязательный параметр инстанс репозитория стран, нужен для предоствращения колизии состояний если их несколько
 * @returns {HotelEntity} hotel entity
 */
export default function HotelFactory(data, countriesRepository) {
    const hotel = buildHotelData(data, countriesRepository);
    return new HotelEntity(hotel);
}